<script setup>
import { ref } from 'vue';
import i18next from 'i18next';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import TutorialBanner from '../../components/TutorialBanner.vue';
import CurrentPriceTargets from '../../components/priceTargets/CurrentPriceTargets.vue';
import AllPriceTargets from '../../components/priceTargets/AllPriceTargets.vue';

const currentPriceTargetsRef = ref(null);
const allPriceTargetsRef = ref(null);

function elOf(refObj) {
    return refObj?.value?.$el ?? refObj?.value ?? null;
}

function startHelpTour() {
    const isMobile = window.innerWidth < 1280;

    const currentEl = elOf(currentPriceTargetsRef);
    const allEl = elOf(allPriceTargetsRef);

    const steps = [
        {
            popover: {
                title: i18next.t('helpTour_priceTargets_step1.title'),
                description: i18next.t('helpTour_priceTargets_step1.description'),
                side: 'bottom',
                align: 'start'
            }
        }
    ];

    if (currentEl) {
        steps.push({
            element: currentEl,
            popover: {
                title: i18next.t('helpTour_priceTargets_step2.title'),
                description: i18next.t('helpTour_priceTargets_step2.description'),
                side: isMobile ? 'top' : 'right',
                align: isMobile ? 'center' : 'start'
            }
        });
    }

    if (allEl) {
        steps.push({
            element: allEl,
            popover: {
                title: i18next.t('helpTour_priceTargets_step3.title'),
                description: i18next.t('helpTour_priceTargets_step3.description'),
                side: isMobile ? 'top' : 'right',
                align: isMobile ? 'center' : 'start'
            }
        });
    }

    driver({
        allowHtml: true,
        showProgress: true,
        nextBtnText: i18next.t('plain_next'),
        prevBtnText: i18next.t('plain_back'),
        doneBtnText: i18next.t('plain_done'),
        steps
    }).drive();
}
</script>

<template>
    <div class="h-full w-full lg:px-20 md:px-10 sm:px-2 bg-[#F1F6FA]">
        <div class="mx-auto container lg:p-4 flex flex-col gap-4">
            <TutorialBanner :title="$t('helpTour_priceTargets_title')" show-until="2025-12-01" @start-tutorial="startHelpTour" />
            <CurrentPriceTargets ref="currentPriceTargetsRef" :link-button="false" />
            <AllPriceTargets ref="allPriceTargetsRef" />
        </div>
    </div>
</template>
